(() => {
  if (customElements.get('orleone-promotion-code')) return;
  customElements.define('orleone-promotion-code', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.button = this.querySelector('button[data-code]');
      if (!this.button) return;
      this.label = this.querySelector('.orleone-promo-code__action');
      this.status = this.querySelector('[role="status"]');
      this.onCopy = () => this.copy();
      this.button.addEventListener('click', this.onCopy);
      this.initialized = true;
    }
    disconnectedCallback() {
      clearTimeout(this.resetTimer);
      this.button?.removeEventListener('click', this.onCopy);
      this.initialized = false;
    }
    async copy() {
      const code = this.button.dataset.code;
      let copied = false;
      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;left:-9999px;top:0;';
        document.body.appendChild(field);
        field.select();
        try { copied = document.execCommand('copy'); } catch { copied = false; }
        field.remove();
        this.button.focus({ preventScroll: true });
      }
      if (copied) {
        this.label.textContent = 'Copied';
        this.dataset.copied = 'true';
        this.status.textContent = 'Discount code ' + code + ' copied.';
      } else {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('.orleone-promo-code__code'));
        selection.removeAllRanges();
        selection.addRange(range);
        this.status.textContent = 'Select and copy discount code ' + code + '.';
      }
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.label.textContent = 'Copy';
        delete this.dataset.copied;
        this.status.textContent = '';
      }, 3000);
    }
  });
})();
